/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  Box,
  Card,
  createFilterOptions,
  Autocomplete,
  TextField,
  MenuItem,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Switch,
  Tooltip,
  Alert
} from '@material-ui/core';
import { DatePicker, LocalizationProvider } from '@material-ui/lab';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import trLocale from 'date-fns/locale/tr';
import commonService from '../../../services/commonService';
import bidService from '../../../services/bidService';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import constants from '../../../utils/constants';
import userService from '../../../services/userService';
import FileDropzoneButton from '../../FileDropzoneButton';
import useFileDropZone from '../../../hooks/useFileDropZone';
import BidGroup from './BidGroup';
import SelectProduct from './SelectProduct';
import helpers from '../../../utils/helpers';
import { Navigate } from 'react-router';
import useAuth from '../../../hooks/useAuth';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';

const filter = createFilterOptions();

// const measurementUnit = [{ value: 1, label: 'Adet' }, { value: 2, label: 'KG' }, { value: 3, label: 'Ton' }];
// const tenderFinishType = [{ value: 1, label: 'Gün' }, { value: 2, label: 'Teklif Sayısı' }];
const tenderFinishValue = [
  { value: 3, label: '3' },
  { value: 12, label: '12' },
  { value: 24, label: '24' },
  { value: 36, label: '36' },
  { value: 48, label: '48' },
  { value: 60, label: '60' },
  { value: 72, label: '72' }
];

// const tenderFinishValue = [];

// for (let i = 1; i <= 30; i++) {
//   tenderFinishValue.push({ value: i, label: i });
// }

const CreateOrderForm = (props) => {
  const { rows, setRows } = props;
  const [productGroups, setProductGroups] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProductGroup, setSelectedProductGroup] = useState({});
  // const [selectedProductGroupId, setSelectedProductGroupId] = useState({});
  const [setSelectedProductGroupId] = useState({});
  const [navigateAccount, setNavigateAccount] = useState(false);
  const [open, toggleOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogType, setDialogType] = useState(constants.creatableType.product);
  const [addresses, setAddresses] = useState([]);
  const [oldFormValues, setOldFormValues] = useState({});
  // const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(true);
  // const [searchKey, setSearchKey] = useState('');
  const [bidRequestGroupId, setRequestBidGroupId] = useState(null);
  const [isMultiple, setIsMultiple] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [onFormSubmitFlag, setOnFormSubmitFlag] = useState(false);
  const [enableFile, setEnableFile] = useState(false);
  const { favSellerGroup } = useAuth();

  const SIZE = 1024 * 1024 * 5;
  const MAX_FILE_COUNT = 5;
  const { cover, handleDropCover, removeFile, handleRemoveCover } = useFileDropZone(SIZE, MAX_FILE_COUNT);

  // const intervalId = useRef(null);

  const changableFields = {
    brand: '',
    quantity: '',
    measurementUnit: '',
    productDetail: '',
    bidRequestGroupId: null,
  };

  const getProdcutGroups = () => commonService.getProductGroup().then((response) => {
    setProductGroups(helpers.nameToTitle(response));
  });

  const getAddresses = () => {
    setShowForm(false);
    userService.getUserAddresses().then((response) => {
      if (response) {
        if (response.length === 0) {
          toast.error('Hesabınıza tanımlı bir adres bulunmadığından ihale açamazsınız. Hesabım sayfasına yönlendiriliyorsunuz. Lütfen bir adres tanımlayınız.');
          setTimeout(() => {
            setNavigateAccount(true);
          }, 3500);
        }
        setAddresses(response);
        setShowForm(true);
      }
    });
  };

  const triggerInput = (enteredName, enteredValue) => {
    const input = document.getElementById(enteredName);
    const lastValue = input.value;
    input.value = enteredValue;
    const event = new Event('input', { bubbles: true });
    const tracker = input._valueTracker;

    if (tracker) {
      tracker.setValue(lastValue);
    }

    input.dispatchEvent(event);
  };

  const submitFile = async (bidRequestId) => {
    if (cover.length === 0) {
      return;
    }
    setFormLoading(true);
    const success = (response, isLast) => {
      if (isLast) {
        toast.success('Dosyalar başarıyla gönderildi');
        handleRemoveCover();
        setFormLoading(false);
      }
    };

    const error = (err, isLast) => {
      toast.error(err.responseText || 'Bir hata oluştu');
      if (isLast) {
        setFormLoading(false);
      }
    };

    cover.forEach((file, index) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bidRequestId', bidRequestId);
      bidService.addBidFile(formData, success, error, cover.length === index + 1);
    });
  };

  const submitRow = (values, resetForm, setFieldValues, setTouched) => {
    const newRow = { ...values };
    const oldValues = { ...values };
    oldValues.bidRequestGroupId = bidRequestGroupId;
    // newRow.productGroupId = parseInt(selectedProductGroupId.toString(), 10);
    newRow.isHidden = isHidden;
    newRow.productId = selectedProductId;
    newRow.paymentMethod = values.paymentMethod.toString();
    newRow.unitofMeasure = constants.measurementUnit.find((f) => f.value === values.measurementUnit).label;
    newRow.bidRequestGroupId = bidRequestGroupId;
    if (!values.onlyFavSellers) {
      newRow.favSellerGroupId = null;
    }
    // newRow.brand = values.brand;
    // newRow.quantity = values.quantity;
    // newRow.currency = values.currency;
    // newRow.unitofMeasure = values.measurementUnit;
    setFormLoading(true);

    bidService.addBid(newRow).then((response) => {
      if (response) {
        const { bidId } = response;
        toast.success('İhale başarıyla oluşturuldu.', { duration: 7000 });
        const newRows = [...rows];
        newRow.bidId = bidId;
        if (newRow.deliveryTime) {
          newRow.deliveryTime = newRow.deliveryTime.toLocaleString('Tr');
        }
        newRow.productName = selectedProducts.title;

        newRows.push(newRow);
        setRows(newRows);

        // Object.keys(changableFields).forEach((key) => {
        //   setFieldValues(key, changableFields[key]);
        //   // oldValues[key] = changableFields[key];
        // });

        if (!isMultiple) {
          resetForm();
          setSelectedProducts('');
          setSelectedProductId(null);
          setOnFormSubmitFlag((prev) => !prev);
        } else {
          setOldFormValues(oldValues);
        }

        Object.keys(changableFields).forEach((key) => {
          setFieldValues(key, changableFields[key]);
          oldValues[key] = changableFields[key];
        });

        setTouched(false);
        // setSelectedProductGroup('');
        submitFile(bidId);
      }
      setFormLoading(false);
    });
  };

  const getDialogTitle = {
    product: 'ürün',
    productGroup: 'ürün grubu',
  };

  const creatableMethods = {
    // productGroup: (title) => {
    //   commonService.addProductGroup({ name: title }).then(async (response) => {
    //     if (response) {
    //       const newProductGroup = {
    //         title,
    //         id: response,
    //       };
    //       setSelectedProductGroupId(newProductGroup.id);
    //       triggerInput('_productGroupId', newProductGroup.title);
    //       const newProductGroups = [...productGroups];
    //       newProductGroups.push(newProductGroup);
    //       setProductGroups(newProductGroups);
    //       setSelectedProductGroup({
    //         title: newProductGroup.title,
    //       });
    //       toast.success(`${getDialogTitle[dialogType]} başarıyla eklendi.`);
    //       toggleOpen(false);
    //     }
    //   });
    // },
    product: (title) => {
      const model = {
        name: title,
        // productGroupId: selectedProductGroupId,
        // onaylanmamıs
        productGroupId: 1315,
      };
      commonService.addProduct(model).then(async (response) => {
        if (response) {
          const newProduct = {
            title,
            id: response
          };
          setSelectedProductId(newProduct.id);
          // triggerInput('_productId', newProduct.title);
          setSelectedProducts({
            title: newProduct.title,
          });
          const newProducts = [...products];
          newProducts.push(newProduct);
          setProducts(newProducts);
          toast.success(`${getDialogTitle[dialogType]} başarıyla eklendi.`);
          toggleOpen(false);
        }
      });
    },
  };

  const getUserStatus = () => {
    userService.getProfile().then((response) => {
      if (response) {
        if (response.status !== undefined && response.status !== 3) {
          toast.error('Hesabınız Onay Aşamasındadır.  Hesabınız Onaylanmadan İhale Açamaz  Açılmış İhalelere Teklif Veremezsiniz. Onay sürecini hızlandırmak için hesabım sayfasındaki profil bilgilerinizi doldurunuz.');
          setTimeout(() => {
            setNavigateAccount(true);
          }, 5500);
        }
      }
    });
  };

  useEffect(() => {
    getUserStatus();
    const getGroup = getProdcutGroups;
    getGroup();
    getAddresses();
  }, []);

  useEffect(() => {
    setFormLoading(!showForm);
  }, [showForm]);

  // useEffect(() => {
  //   if (selectedProductGroup && selectedProductGroup.title) {
  //     const group = productGroups.find((f) => f.title === selectedProductGroup.title);
  //     const getProduct = getProdcuts;
  //     getProduct(group.id);
  //   }
  // }, [selectedProductGroup]);

  // useEffect(() => {
  //   if (searchKey) {
  //     if (intervalId.current) {
  //       clearTimeout(intervalId.current);
  //     }
  //     intervalId.current = setTimeout(() => {
  //       commonService.getProductByKey(searchKey).then((response) => {
  //         if (response) {
  //           if (Array.isArray(response)) {
  //             setProducts(nameToTitle(response));
  //             if (response.length === 0) {
  //               const newOptions = [];
  //               newOptions.push({
  //                 inputValue: searchKey,
  //                 title: `Ekle "${searchKey}"`,
  //               });
  //               setProducts(newOptions);
  //             }
  //           }
  //         }
  //       });
  //     }, 500);
  //   }
  // }, [searchKey]);
  return (
    navigateAccount ? (<Navigate to="/account?tab=profile" />) : (
      <>
        <Card
          sx={{ position: 'relative', }}
          id="drawer-container"
        >
          <SelectProduct
            selectProduct={(prs, pr) => {
              setProducts(prs.map((m) => ({
                title: m.name,
                id: m.id,
                optionValue: m.name
              })));
              setSelectedProducts({
                title: pr.name,
                id: pr.id
              });
              setSelectedProductId(pr.id);
            }}
            createNew={(key) => {
              setDialogTitle(key);
              setDialogType(constants.creatableType.product);
              toggleOpen(true);
            }}
            formSubmitFlag={onFormSubmitFlag}
          />
          {
            (formLoading ? (
              <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                height: '250px',
                alignItems: 'center'
              }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Formik
                initialValues={{
                  // comment: '',
                  brand: oldFormValues.brand || '',
                  quantity: oldFormValues.quantity || '',
                  measurementUnit: oldFormValues.measurementUnit || '',
                  paymentMethod: oldFormValues.paymentMethod || '',
                  deliveryTime: oldFormValues.deliveryTime || null,
                  addressId: oldFormValues.addressId ? oldFormValues.addressId : (addresses.length === 1 ? addresses[0]?.id : ''),
                  tenderFinishType: oldFormValues.tenderFinishType || 1,
                  tenderFinishValue: oldFormValues.tenderFinishValue || 24,
                  checkExpiry: oldFormValues.checkExpiry || null,
                  cariExpiry: oldFormValues.cariExpiry || null,
                  productDetail: oldFormValues.productDetail || '',
                  currency: oldFormValues.currency || 'TRY',
                  favSellerGroupId: oldFormValues.favSellerGroupId || [],
                  // tenderEndBid: 10,
                  // tenderEndDay: 15,
                  onlyFavSellers: oldFormValues.onlyFavSellers || false,
                }}
                onSubmit={(values, { resetForm, setFieldValue, setTouched }) => {
                  submitRow(values, resetForm, setFieldValue, setTouched);
                }}
                validationSchema={Yup
                  .object()
                  .shape({
                    // _productGroupId: Yup
                    //   .string()
                    //   .required('*zorunlu'),
                    // _productId: Yup
                    //   .string()
                    //   .required('*zorunlu'),
                    // comment: Yup
                    //   .string()
                    //   .nullable(),
                    brand: Yup
                      .string()
                      .nullable(),
                    quantity: Yup
                      .number()
                      .required('*zorunlu').min(1, 'Miktar 1\'den az olamaz'),
                    measurementUnit: Yup
                      .string()
                      .required('*zorunlu'),
                    paymentMethod: Yup
                      .string()
                      .required('*zorunlu'),
                    // deliveryTime: Yup
                    //   .string()
                    //   .required('*zorunlu'),
                    // checkExpiry: Yup
                    //   .number()
                    //   .when('paymentMethod', {
                    //     is: (value) => (value === constants.paymentMethodsValue.check),
                    //     then: Yup.number().required('Falan filan'),
                    //     otherwise: Yup.number()
                    //   }),
                    addressId: Yup
                      .string()
                      .required('*zorunlu'),
                    // checkExpiry: Yup
                    //   .number()
                    //   .nullable()
                    //   .max(1000, 'Çek vadesi 1000 günden fazla olamaz.')
                    //   .min(1, 'Çek vadesi 1 günden az olamaz'),
                    checkExpiry: Yup.number()
                      .when('paymentMethod', {
                        is: (paymentMethod) => {
                          // eslint-disable-next-line eqeqeq
                          return (paymentMethod == constants.paymentMethodsValue.check);
                        },
                        then: Yup.number().nullable().required('*zorunlu').max(1000, 'Çek vadesi 1000 günden fazla olamaz.')
                          .min(1, 'Çek vadesi 1 günden az olamaz'),
                        otherwise: Yup.number().nullable().max(1000, 'Çek vadesi 1000 günden fazla olamaz.').min(1, 'Çek vadesi 1 günden az olamaz'),
                      }),
                    cariExpiry: Yup.number()
                      .when('paymentMethod', {
                        is: (paymentMethod) => {
                          // eslint-disable-next-line eqeqeq
                          return (paymentMethod == constants.paymentMethodsValue.cari);
                        },
                        then: Yup.number().nullable().required('*zorunlu').max(1000, 'Cari vadesi 1000 günden fazla olamaz.')
                          .min(1, 'Cari vadesi 1 günden az olamaz'),
                        otherwise: Yup.number().nullable().max(1000, 'Cari vadesi 1000 günden fazla olamaz.').min(1, 'Cari vadesi 1 günden az olamaz'),
                      }),
                    productDetail: Yup.string().required('*zorunlu').max(200, 'Ürün açıklaması 200 karakterden fazla olamaz'),
                    onlyFavSellers: Yup.bool().nullable(),
                  })}
              >
                {

                  ({ errors, handleChange, handleSubmit, touched, values, setFieldValue }) => {
                    return (
                      <form
                        noValidate
                        onSubmit={handleSubmit}
                      >
                        {/* <input
                    hidden
                    id="_productGroupId"
                    name="_productGroupId"
                    value={values._productGroupId}
                    onChange={handleChange}
                  /> */}
                        {/* <input
                        hidden
                        name="_productId"
                        id="_productId"
                        value={values._productId}
                        onChange={handleChange}
                      /> */}
                        <Grid
                          container
                          spacing={2}
                          className="tp-cof__grid"
                        >
                          <Grid
                            item
                            xs={12}
                          >
                            <Box
                              className="tp-cof__bottom"
                              sx={{
                                display: 'flex',
                                flexFlow: 'column wrap',
                                m: 1,
                                p: 2
                              }}
                            >
                              <Box
                                // className="input-wrapper"
                                className="tp-new-order-switch-group"
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  flexWrap: 'wrap',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  m: 1,
                                }}
                              >
                                <Box className="tp-new-order-switch-group-inside">
                                  <Box
                                    className="tp-new-order-switch-group-item"
                                    sx={{
                                      m: 1,
                                      width: 300,
                                      display: 'inline-block'
                                    }}
                                  >
                                    <Tooltip title="Sadece işaretleyeceğiniz favori firma gruplarındaki firmalar ihalelerinizi görebilir.">
                                      <FormGroup className="tp-form-tooltip__group">
                                        <FormControlLabel
                                          className="tp-switch__item"
                                          control={(
                                            <Switch
                                              checked={values.onlyFavSellers}
                                              onChange={() => setFieldValue('onlyFavSellers', !values.onlyFavSellers)}
                                            />
                                          )}
                                          label="Favori Firmalarıma Özel İhale Aç"
                                          sx={{ whiteSpace: 'nowrap' }}
                                        />
                                        <LiveHelpIcon className="icon-border" />
                                      </FormGroup>
                                    </Tooltip>
                                    {
                                      values.onlyFavSellers && (
                                        <Box
                                          sx={{
                                            m: 1,
                                            width: 50,
                                            display: 'inline-block'
                                          }}
                                        >
                                          <TextField
                                            select
                                            name="favSellerGroupId"
                                            onChange={handleChange}
                                            fullWidth
                                            label="Favori Grubu"
                                            variant="outlined"
                                            sx={{ width: 200 }}
                                            value={values.favSellerGroupId}
                                            SelectProps={{
                                              multiple: true,
                                            }}
                                          >
                                            {
                                              favSellerGroup.map((group) => (
                                                <MenuItem
                                                  value={group.id}
                                                  key={group.id}
                                                >
                                                  {`${group.groupName} (${group.companies.length})`}
                                                </MenuItem>
                                              ))
                                            }
                                          </TextField>
                                          {/* <FavoritesGroupButton /> */}
                                        </Box>
                                      )
                                    }
                                  </Box>
                                  <Box
                                    className="tp-new-order-switch-group-item"
                                    sx={{
                                      m: 2,
                                      width: 250,
                                      display: 'inline-block'
                                    }}
                                  >
                                    <Tooltip title="Firma adınızı gizler, teklif verecek firmalar firma adınızı göremezler.">
                                      <FormGroup className="tp-form-tooltip__group">
                                        <FormControlLabel
                                          className="tp-switch__item"
                                          control={(
                                            <Switch
                                              checked={isHidden}
                                              onChange={() => setIsHidden(!isHidden)}
                                            />
                                          )}
                                          label="Açılan ihalede adımı gizle"
                                          sx={{ whiteSpace: 'nowrap' }}
                                        />
                                        <LiveHelpIcon className="icon-border" />
                                      </FormGroup>
                                    </Tooltip>
                                  </Box>

                                  <Box
                                    className="tp-new-order-switch-group-item"
                                    sx={{
                                      m: 2,
                                      width: 200,
                                      display: 'inline-block'
                                    }}
                                  >
                                    <Tooltip title="İhale aç sayfasındaki parametrelerinizi kaybetmeden birden çok ihale açmanıza olanak sağlar.">
                                      <FormGroup className="tp-form-tooltip__group">
                                        <FormControlLabel
                                          className="tp-switch__item"
                                          control={(
                                            <Switch
                                              checked={isMultiple}
                                              onChange={() => setIsMultiple(!isMultiple)}
                                            />
                                          )}
                                          label="Çoklu İhale"
                                          sx={{ whiteSpace: 'nowrap' }}
                                        />
                                        <LiveHelpIcon className="icon-border" />
                                      </FormGroup>
                                    </Tooltip>
                                  </Box>
                                </Box>
                                <Box>
                                  <Box
                                    sx={{
                                      m: 1,
                                      width: 200
                                    }}
                                  >
                                    <BidGroup setSelectedBidGroup={setRequestBidGroupId} />
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  m: 2,
                                }}
                              >
                                <TextField
                                  fullWidth
                                  label="Ürün Detayı"
                                  placeholder="Aramış olduğunuz ürün ya da hizmete ait tüm detayları yazınız."
                                  variant="outlined"
                                  name="productDetail"
                                  inputProps={{ maxLength: 200 }}
                                  multiline
                                  rows={2}
                                  value={values.productDetail}
                                  onChange={handleChange}
                                  error={Boolean(touched.productDetail && errors.productDetail)}
                                  helperText={touched.productDetail && errors.productDetail}
                                  autoComplete="off"
                                  disabled={!selectedProductId}
                                />
                              </Box>
                              <Box
                                // className="input-wrapper"
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  flexWrap: 'wrap',
                                  alignItems: 'center',
                                  m: 1,
                                }}
                              >
                                {/* <Box
                        sx={{
                          m: 1,
                          maxWidth: '100%',
                          width: 240
                        }}
                      >
                        <Autocomplete
                          freeSolo
                          name="productGroupIdComplete"
                          value={selectedProductGroup}
                          onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                              triggerInput('_productGroupId', newValue);
                              setSelectedProductGroup({
                                title: newValue,
                              });
                              setSelectedProductGroupId(productGroups.find((f) => f.title === newValue).id);
                            } else if (newValue && newValue.inputValue) {
                              setDialogTitle(newValue.inputValue);
                              setDialogType(constants.creatableType.productGroup);
                              toggleOpen(true);
                            } else {
                              setSelectedProductGroup({
                                ...newValue,
                              });
                            }
                          }}
                          options={productGroups.map((group) => group.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Ürün Grubu"
                              variant="outlined"
                              fullWidth
                              error={Boolean(touched._productGroupId && errors._productGroupId)}
                              helperText={touched._productGroupId && errors._productGroupId}
                            />
                          )}
                          getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                              return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                              return option.title;
                            }
                            // Regular option
                            return option.title || '';
                          }}
                          filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            if (params.inputValue !== '') {
                              filtered.push({
                                inputValue: params.inputValue,
                                title: `İhale Aç "${params.inputValue}"`,
                              });
                            }
                            return filtered;
                          }}
                        />
                      </Box> */}
                                {/* <Box
                        sx={{
                          m: 1,
                          width: 200
                        }}
                      >
                        <Autocomplete
                          freeSolo
                          name="productIdComplete"
                          value={selectedProducts}
                          open={openProduct}
                          onOpen={() => {
                            setOpenProduct(true);
                          }}
                          onClose={() => {
                            setOpenProduct(false);
                          }}
                          onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                              let pro = products.find((f) => f.title === newValue && !f.inputValue);
                              if (!pro) {
                                pro = products.find((f) => f.title === newValue);
                                setDialogTitle(pro.inputValue);
                                setDialogType(constants.creatableType.product);
                                toggleOpen(true);
                                pro.title = pro.inputValue;
                                setProducts([pro]);
                              } else {
                                triggerInput('_productId', newValue);
                                setSelectedProducts({
                                  title: newValue,
                                });
                                setSelectedProductId(pro.id);
                              }
                            } else {
                              setSelectedProductId(null);
                            }
                          }}
                          loading={loading}
                          loadingText="Yükleniyor.."
                          options={products.map((group) => group.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Ürünler"
                              variant="outlined"
                              fullWidth
                              error={Boolean(touched._productId && errors._productId)}
                              helperText={touched._productId && errors._productId}
                              placeholder="Ürün yazın"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                              key={params.id}
                            />
                          )}
                          getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                              if (option.split('"').length > 1) {
                                console.log(option);
                              }
                              return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                              return option.title;
                            }
                            // Regular option
                            return option.title || option.name || '';
                          }}
                          filterOptions={(options, params) => {
                            if (params.inputValue && !loading) {
                              setLoading(true);
                            }
                            setSearchKey(params.inputValue);
                            return options;
                          }}
                        />
                      </Box> */}
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <TextField
                                    label="Miktar"
                                    name="quantity"
                                    variant="outlined"
                                    type="number"
                                    inputProps={{ min: 1, max: 999999 }}
                                    fullWidth
                                    value={values.quantity}
                                    onChange={handleChange}
                                    error={Boolean(touched.quantity && errors.quantity)}
                                    helperText={touched.quantity && errors.quantity}
                                    disabled={!selectedProductId}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <TextField
                                    id="measurement-unit"
                                    name="measurementUnit"
                                    select
                                    label="Ölçü Birimi"
                                    fullWidth
                                    value={values.measurementUnit}
                                    onChange={handleChange}
                                    error={Boolean(touched.measurementUnit && errors.measurementUnit)}
                                    helperText={touched.measurementUnit && errors.measurementUnit}
                                    disabled={!selectedProductId}
                                  >
                                    {constants.measurementUnit.map((option) => (
                                      <MenuItem
                                        key={option.value}
                                        value={option.value}
                                        title={option.title}
                                      >
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </Box>
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <TextField
                                    id="payment-method"
                                    select
                                    name="paymentMethod"
                                    label="Ödeme Türü"
                                    value={values.paymentMethod}
                                    onChange={handleChange}
                                    fullWidth
                                    error={Boolean(touched.paymentMethod && errors.paymentMethod)}
                                    helperText={touched.paymentMethod && errors.paymentMethod}
                                    disabled={!selectedProductId}
                                  >
                                    {constants.paymentMethods.map((option) => (
                                      <MenuItem
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </Box>
                                {
                                  values.paymentMethod === constants.paymentMethodsValue.check && (
                                    <Box
                                      sx={{
                                        m: 1,
                                        width: 200
                                      }}
                                    >
                                      <TextField
                                        fullWidth
                                        label="Vade"
                                        type="number"
                                        placeholder="Gün sayısı"
                                        name="checkExpiry"
                                        value={values.checkExpiry}
                                        onChange={handleChange}
                                        error={Boolean(touched.checkExpiry && errors.checkExpiry)}
                                        helperText={touched.checkExpiry && errors.checkExpiry}
                                        autoComplete="off"
                                        inputProps={{
                                          max: 1000,
                                          min: 1
                                        }}
                                      />
                                    </Box>
                                  )
                                }
                                {
                                  values.paymentMethod === constants.paymentMethodsValue.cari && (
                                    <Box
                                      sx={{
                                        m: 1,
                                        width: 200
                                      }}
                                    >
                                      <TextField
                                        fullWidth
                                        label="Cari Vadesi"
                                        type="number"
                                        placeholder="Gün sayısı"
                                        name="cariExpiry"
                                        value={values.cariExpiry}
                                        onChange={handleChange}
                                        error={Boolean(touched.cariExpiry && errors.cariExpiry)}
                                        helperText={touched.cariExpiry && errors.cariExpiry}
                                        autoComplete="off"
                                        inputProps={{
                                          max: 1000,
                                          min: 1
                                        }}
                                        disabled={!selectedProductId}
                                      />
                                    </Box>
                                  )
                                }
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <TextField
                                    label="Marka"
                                    name="brand"
                                    variant="outlined"
                                    type="text"
                                    inputProps={{ maxLength: 20 }}
                                    fullWidth
                                    value={values.brand}
                                    onChange={handleChange}
                                    error={Boolean(touched.brand && errors.brand)}
                                    helperText={touched.brand && errors.brand}
                                    autoComplete="off"
                                    disabled={!selectedProductId}
                                  />
                                </Box>
                                <Box sx={{
                                  m: 1,
                                  width: 200
                                }}
                                >
                                  <TextField
                                    name="addressId"
                                    select
                                    label="Adres"
                                    fullWidth
                                    value={values.addressId}
                                    onChange={handleChange}
                                    error={Boolean(touched.addressId && errors.addressId)}
                                    helperText={touched.addressId && errors.addressId}
                                    disabled={!selectedProductId}
                                  >
                                    {addresses.map((option) => (
                                      <MenuItem
                                        key={option.id}
                                        value={option.id}
                                      >
                                        {option.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>

                                </Box>
                                <Box sx={{
                                  m: 1,
                                  width: 200
                                }}
                                >
                                  <TextField
                                    name="currency"
                                    select
                                    label="Para Birimi"
                                    value={values.currency}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    disabled={!selectedProductId}
                                  >
                                    {constants.currencies.map((option) => (
                                      <MenuItem
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {`${option.label} ${option.value} `}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </Box>
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    locale={trLocale}
                                  >
                                    <DatePicker
                                      name="deliveryTime"
                                      mask="__.__.____"
                                      value={values.deliveryTime}
                                      label="Termin Süresi"
                                      onChange={(newVal) => setFieldValue('deliveryTime', newVal)}
                                      disablePast
                                      renderInput={(params) => (
                                        <TextField
                                          id="deliveryTime"
                                          fullWidth
                                          {...params}
                                          error={Boolean(touched.deliveryTime && errors.deliveryTime)}
                                          helperText={touched.deliveryTime && errors.deliveryTime}
                                        />
                                      )}
                                      disabled={!selectedProductId}
                                    />
                                  </LocalizationProvider>
                                </Box>
                                <Box
                                  sx={{
                                    m: 1,
                                    width: 200
                                  }}
                                >
                                  <TextField
                                    id="tender-finish-param"
                                    name="tenderFinishValue"
                                    select
                                    label="İhale Süresi (Saat)"
                                    fullWidth
                                    value={values.tenderFinishValue}
                                    onChange={handleChange}
                                    disabled={!selectedProductId}
                                  >
                                    {tenderFinishValue.map((option) => (
                                      <MenuItem
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </Box>
                              </Box>
                              {/* <Box
                        // className="input-wrapper"
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          m: 1,
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                        }}
                      >
                        <Box sx={{
                          display: 'flex',
                          m: 1,
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                        }}
                        >
                          <Box
                        sx={{
                          m: 1,
                          width: 200
                        }}
                      >
                        <TextField
                          id="tender-finish-type"
                          name="tenderFinishType"
                          select
                          label="İhale Bitiş Kuralı"
                          fullWidth
                          value={values.tenderFinishType}
                          onChange={handleChange}
                        >
                          {tenderFinishType.map((option) => (
                            <MenuItem
                              key={option.value}
                              value={option.value}
                              selected={option.selected}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                        </Box>
                      </Box> */}
                              <Box sx={{
                                m: 1,
                                display: 'flex',
                                flexFlow: 'column nowrap'
                              }}
                              >
                                <Box
                                  sx={{
                                    m: 2,
                                    width: 200,
                                  }}
                                >
                                  <FormControlLabel
                                    className="tp-switch__item"
                                    control={(
                                      <Switch
                                        checked={enableFile}
                                        onChange={() => setEnableFile(!enableFile)}
                                      />
                                    )}
                                    label="Dosya eklemek istiyorum"
                                    sx={{ whiteSpace: 'nowrap' }}
                                  />
                                </Box>
                                {
                                  enableFile && (
                                    <Box
                                      sx={{
                                        m: 1,
                                        width: 400
                                      }}
                                    >
                                      <FileDropzoneButton
                                        accept={['image/*', '.pdf', '.xls', '.xlsx', '.csv', '.doc', '.docx']}
                                        maxFiles={10}
                                        className="dropzone-files"
                                        onDrop={handleDropCover}
                                        files={cover}
                                        onRemove={removeFile}
                                        onRemoveAll={handleRemoveCover}
                                        maxSize={SIZE}
                                        disabled={!selectedProductId}
                                      />
                                    </Box>
                                  )
                                }
                              </Box>
                              {/* <Box sx={{
                          display: 'flex',
                          flexFlow: 'row nowrap',
                          m: 1,
                        }}
                        >
                          <Grid
                            container
                            spacing={2}
                          >
                            <Grid
                              item
                              xs={12}
                              lg={6}
                            >
                              <Box
                                sx={{
                                  m: 1,
                                  width: 200
                                }}
                              >
                                <TextField
                                  name="addressId"
                                  select
                                  label="Adres"
                                  fullWidth
                                  value={values.addressId}
                                  onChange={handleChange}
                                  error={Boolean(touched.addressId && errors.addressId)}
                                  helperText={touched.addressId && errors.addressId}
                                  disabled={!selectedProductId}
                                >
                                  {addresses.map((option) => (
                                    <MenuItem
                                      key={option.id}
                                      value={option.id}
                                    >
                                      {option.name}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Box>
                              <Box
                                sx={{
                                  m: 1,
                                }}
                                className="detail-description"
                              >
                                <TextField
                                  fullWidth
                                  label="Detaylı Açıklama"
                                  variant="outlined"
                                  name="comment"
                                  multiline
                                  rows={3}
                                  value={values.comment}
                                  onChange={handleChange}
                                  error={Boolean(touched.comment && errors.comment)}
                                  helperText={touched.comment && errors.comment}
                                  autoComplete="off"
                                  disabled={!selectedProductId}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              lg={4}
                            >
                              <Box
                                sx={{
                                  m: 1,
                                }}
                              >
                                <FileDropzone
                                  accept={['image/*', '.pdf', '.xls', '.xlsx', '.csv', '.doc', '.docx']}
                                  maxFiles={10}
                                  className="dropzone-files"
                                  onDrop={handleDropCover}
                                  files={cover}
                                  onRemove={removeFile}
                                  onRemoveAll={handleRemoveCover}
                                  maxSize={SIZE}
                                  disabled={!selectedProductId}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </Box> */}
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexFlow: 'row nowrap',
                                  m: 2,
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Box>
                                  <Tooltip title={selectedProductId ? 'İhale aç' : 'Lütfen ürün seçiniz'}>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      type="submit"
                                      size="large"
                                      sx={{
                                        width: 300
                                      }}
                                    // disabled={!selectedProductId}
                                    >
                                      İhale Aç
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </form>
                    );
                  }
                }
              </Formik>
            ))
          }
        </Card>
        <Dialog
          open={open}
          onClose={() => toggleOpen(false)}
          aria-labelledby="form-dialog-title"
          fullWidth="sm"
          maxWidth="sm"
        >
          <Formik
            initialValues={
              {
                title: dialogTitle,
                _productGroupId: ''
              }
            }
            validationSchema={Yup.object().shape({
              title: Yup.string().required('zorunlu'),
              // _productGroupId: Yup.string().required('zorunlu'),
            })}
            onSubmit={(values) => {
              creatableMethods[dialogType](values.title);
            }}
          >
            {
              ({ values, errors, touched, handleSubmit, handleChange }) => (
                <form onSubmit={handleSubmit}>
                  <DialogTitle id="form-dialog-title">{`Yeni bir ${getDialogTitle[dialogType]} ekle`}</DialogTitle>
                  <DialogContent>
                    <input
                      hidden
                      id="_productGroupId"
                      name="_productGroupId"
                      value={values._productGroupId}
                      onChange={handleChange}
                    />
                    <Box sx={{
                      m: 1,
                      width: 520
                    }}
                    >
                      <Autocomplete
                        hidden
                        freeSolo
                        name="productGroupIdComplete"
                        value={selectedProductGroup}
                        onChange={(event, newValue) => {
                          if (typeof newValue === 'string') {
                            triggerInput('_productGroupId', newValue);
                            setSelectedProductGroup({
                              title: newValue,
                            });
                            setSelectedProductGroupId(productGroups.find((f) => f.title === newValue).id);
                          } else if (newValue && newValue.inputValue) {
                            setDialogTitle(newValue.inputValue);
                            setDialogType(constants.creatableType.productGroup);
                            toggleOpen(true);
                          } else {
                            setSelectedProductGroup({
                              ...newValue,
                            });
                          }
                        }}
                        options={productGroups.map((group) => group.title)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Ürün Grubu"
                            variant="outlined"
                            fullWidth
                            error={Boolean(touched._productGroupId && errors._productGroupId)}
                            helperText={touched._productGroupId && errors._productGroupId}
                          />
                        )}
                        getOptionLabel={(option) => {
                          // Value selected with enter, right from the input
                          if (typeof option === 'string') {
                            return option;
                          }
                          // Add "xxx" option created dynamically
                          if (option.inputValue) {
                            return option.title;
                          }
                          // Regular option
                          return option.title || '';
                        }}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);

                          return filtered;
                        }}
                      />
                      <Alert
                        severity="error"
                        className="tp-oc-alert"
                      >
                        Mevcut ürünler haricinde yeni bir ürün ekleyerek ihale açmanız durumunda, ihaleniz
                        {' '}
                        <strong>onay sürecine</strong>
                        {' '}
                        dahil olacaktır.
                        {' '}
                        İhaleniz onaylandığında diğer kullanılar tarafından görüntülenebilecek ve size mail olarak bildirilecektir.
                      </Alert>
                    </Box>
                    <Box sx={{
                      m: 1,
                      width: 520
                    }}
                    >
                      <TextField
                        autoFocus
                        margin="dense"
                        fullWidth
                        id="title"
                        value={values.title}
                        onChange={handleChange}
                        label="Ürün/Hizmet Adı"
                        type="text"
                        error={Boolean(touched.title && errors.title)}
                        helperText={touched.title && errors.title}
                      />
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => {
                        toggleOpen(false);
                        if (dialogType === 'product') {
                          setSelectedProducts('');
                          triggerInput('_productId', '');
                        } else {
                          // setSelectedProductGroup('');
                          triggerInput('_productGroupId', '');
                        }
                      }}
                      color="primary"
                    >
                      İptal
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                    >
                      Ekle
                    </Button>
                  </DialogActions>
                </form>
              )
            }
          </Formik>
        </Dialog>
      </>
    )
  );
};

export default CreateOrderForm;

CreateOrderForm.propTypes = {
  rows: PropTypes.array,
  setRows: PropTypes.func
};

CreateOrderForm.defaultProps = {
  rows: [],
  setRows: () => { },
};
// {/* <Box
//                     sx={{
//                       m: 1,
//                       width: 310
//                     }}
//                   >
//                     <div className={classes.root}>
//                       <Typography id="discrete-slider" gutterBottom>
//                         İhale Bitiş  (Gün)
//                       </Typography>
//                       <Slider
//                         name="tenderEndDay"
//                         value={values.tenderEndDay}
//                         onChange={handleChange}
//                         max={30}
//                         min={1}
//                         getAriaValueText={bidFinishDayValue}
//                         aria-labelledby="discrete-slider"
//                         step={1}
//                         marks={dayMarks}
//                         valueLabelDisplay="auto"
//                       />
//                     </div>
//                   </Box>
//                   <Box
//                     sx={{
//                       m: 1,
//                       width: 310
//                     }}
//                   >
//                     <div className={classes.root}>
//                       <Typography id="discrete-slider" gutterBottom>
//                         İhale Bitiş  (Teklif)
//                       </Typography>
//                       <Slider
//                         name="tenderEndBid"
//                         value={values.tenderEndBid}
//                         onChange={handleChange}
//                         max={15}
//                         min={1}
//                         getAriaValueText={bidFinishValue}
//                         aria-labelledby="discrete-slider"
//                         step={1}
//                         marks={bidMarks}
//                         valueLabelDisplay="auto"
//                       />
//                     </div>
//                   </Box> */}
